import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, TextField, Typography, Container, Box, Grid2 as Grid, Paper, CircularProgress } from '@mui/material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import LangSelect from '@components/LangSelect';

function ForgotPasswordPage() {
  const { t, i18n } = useTranslation();
  const { showMessage } = useSnackbar();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await API.post('/auth/password/email', { email });
      setResponse(response.data);
    } catch (err) {
      showMessage(
        err.response?.data?.message ? t(err.response.data.message) : err.message,
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={{ width: '100%', p: 4, mt: { xs: 2, sm: 6, md: 12 } }}>
        <img src="/logo.webp" alt="Logo" style={{ width: '100%', height: 'auto', marginBottom: 16 }} />

        <Grid container>
          <Grid size="grow" xs>
            <Typography component="h1" variant="h2">
              {t("Forgot Password")}
            </Typography>
          </Grid>
          <Grid>
            <LangSelect
              variant="standard"
              value={i18n.language}
              onChange={handleLanguageChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Language' }}
            />
          </Grid>
        </Grid>

        {response ? (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
              {t("Email")} : {email}
            </Typography>
            <Typography sx={{ mt: 2 }}>
              {t(response.message)}
            </Typography>

            <Grid container justifyContent="center" sx={{ mt: 2 }}>
              <Grid>
                <Link to="/login" style={{ textDecoration: 'none' }}>
                  <Typography variant="body2" color="primary">
                    {t('Back to login')}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </>
        ) : (
          <>

          <Typography sx={{ mt: 2 }}>
            {t("Enter your email address. We will send you a link to reset your password.")}
          </Typography>

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label={t("Email Address")}
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t('Validate')
              )}
            </Button>
            <Grid container justifyContent="center">
              <Grid>
                <Link to="/login" style={{ textDecoration: 'none' }}>
                  <Typography variant="body2" color="primary">
                    {t('Cancel')}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Box>
          </>
        )}
      </Paper>
    </Container>
  );
}

export default ForgotPasswordPage; 